<template>
  <div>
    <div class="menu">
        <div class="container">
            <div class="list">
                <ul class="clearfix">
                    <li>
                        <a href="javascript:;">
                            <img src="/static/img/icon_yanjiyuan1.png">
                            <p>特聘研究员</p>
                        </a>
                    </li>
                    <li>
                        <router-link :to="`${querypath}?type=zyrc`" >
                            <img src="/static/img/icon_peixunzs3.png">
                            <p> 测评查询</p>
                        </router-link>
                    </li>
                    <li>
                        <a href="javascript:;">
                            <img src="/static/img/icon_rongyuzhengshu2.png">
                            <p>荣誉查询</p>
                        </a>
                    </li>

                    

                    <li>
                        <router-link :to="`/news/views/${Groups[0].plateId}`">
                            <img src="/static/img/icon_peixunjidi4.png">
                            <p>培训基地</p>
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="`/news/views/${Groups[1].plateId}`">
                            <img src="/static/img/icon_hangyzj5.png">
                            <p>行业专家</p>
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="`/news/views/${Groups[2].plateId}`">
                            <img src="/static/img/icon_xsgw6.png">
                            <p>学术顾问</p>
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="`/news/views/${Groups[3].plateId}`">
                            <img src="/static/img/icon_lxzt7.png">
                            <p>立项课题</p>
                        </router-link>
                    </li>

                    <li>
                        <router-link :to="`/news/views/${Groups[4].plateId}`">
                            <img src="/static/img/icon_jxzt8.png">
                            <p>结项课题</p>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="index-news">
      <div class="container">
          <div class="box clearfix">
              <div class="box-item">
                  <div class="inner titleChange">
                      <div class="title-box clearfix">
                          <div class="list">
                              <ul class="clearfix">
                                  <li class="active">政策法规</li>
                              </ul>
                          </div>
                          <div class="link">
                              <router-link :to="`/news/views/${Groups[5].plateId}`">
                                  <span>更多&nbsp;&gt;</span>
                              </router-link>
                          </div>
                      </div>
                      <div class="newsList">
                          <!--学者论述-->
                          <div class="child" style="display: block;" v-if="Groups[5]">
                              <ul>
                                  <li class="clearfix" v-for="(article , index) in  Groups[5].articles" :key="index"><span class="date">{{article.addtime.slice(0,10)}}</span>
                                      <div class="title"><router-link
                                              :to="`/news/info/${article.plateid}/${article._id}`">{{article.title}}</router-link>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="box-item">
                  <div class="inner titleChange">
                      <div class="title-box clearfix">
                          <div class="list">
                              <ul class="clearfix">
                                  <li class="active">培训信息</li>
                              </ul>
                          </div>
                          <div class="link">
                             <router-link :to="`/news/views/${Groups[6].plateId}`">
                                  <span>更多&nbsp;&gt;</span>
                              </router-link>
                          </div>
                      </div>
                      <div class="newsList">
                          <!--文化体育-->
                          <div class="child" style="display: block;" v-if="Groups[6]">
                              <ul>
                                  <li class="clearfix" v-for="(article , index) in  Groups[6].articles" :key="index"><span class="date">{{article.addtime.slice(0,10)}}</span>
                                      <div class="title"><router-link
                                              :to="`/news/info/${article.plateid}/${article._id}`">{{article.title}}</router-link>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
       Groups: [
        {
          name: "培训基地", 
        },
        {
          name: "行业专家", 
        },
        {
          name: "学术顾问", 
        },
        {
          name: "立项课题", 
        },
        {
          name: "结项课题", 
        },
        {
          name: "政策法规", 
        },
        {
          name: "培训信息", 
        }
      ],
      querypath:global.isPhone()?'/inqCertM':'/inqCert'
    };
  },
  mounted() {
    let watchflag = 0;
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          break;
        }
      }
    }
     for (let k = 5; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt&limit=7`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data);
                this.$forceUpdate();
              }
            });
            break;
        }
      }
     }
  },
   methods: {
    getDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return now.getDate();
    },
    getMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}`;
    },
    getYearMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getFullYear()}-${now.getMonth() + 1}`;
    },
  },
};
</script>
<style scoped>
@media screen and (min-width:480px) {
.xwscolf {
    width: 30%;
    float: left;
    height: auto;
    
}

.xwscolfc {
    width:  30%;
    float: left;
    height: auto;
    margin-left:5%;
}

.xwscolfr {
    width:  30%;
    float: right;
    height: auto;
}
/deep/ .el-card__body{
      padding: 25px;
}
}
.Inqclss{
    font-size: 33px;
    font-family: 黑体;
    font-weight: 600;
    color: #fff;
}
@media screen and (max-width:480px) {
  .xwscolf {
      width: 92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }

  .xwscolfc {
      width:  92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }

  .xwscolfr {
      width:  92%;
      height: auto;
      margin-bottom: 18px;
      left:4%;
      position: relative;
  }
  /deep/ .el-card__body{
      padding: 10px;
  }
  .Inqclss{
    font-size: 28px;
    font-family: 黑体;
    font-weight: 600;
    color: #fff;
  }
}



/deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
  box-shadow: 0 2px 12px 0 rgb(206 26 18);
}
/deep/ .el-card{
  border: 1px solid #ce1a12;
}
.index-news .box-item{
  width: 50%;
}
</style>
